module.exports = __webpack_public_path__ + "static/img/logo_aboutUS.2e6adf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/logo_aboutUS.png
// module id = +P2M
// module chunks = 7